import { css as v, LitElement as p, html as d } from "lit";
import { property as c, customElement as m } from "lit/decorators.js";
import { b as f, f as g } from "./styles-scZ6dVz-.js";
var b = Object.defineProperty, u = Object.getOwnPropertyDescriptor, s = (n, t, o, a) => {
  for (var r = a > 1 ? void 0 : a ? u(t, o) : t, l = n.length - 1, i; l >= 0; l--)
    (i = n[l]) && (r = (a ? i(t, o, r) : i(r)) || r);
  return a && r && b(t, o, r), r;
};
let e = class extends p {
  constructor() {
    super(...arguments), this.hoverable = !1, this.active = !1;
  }
  render() {
    return d`
      <div class="item" part="item">
        <div class="leading" part="leading">
          <slot name="leading"></slot>
        </div>
        <div class="content" part="content">
          <div class="label" part="label">
            <slot></slot>
          </div>
          <div class="meta" part="meta">
            <slot name="meta"></slot>
          </div>
        </div>
        <div class="trailing" part="trailing">
          <slot name="trailing"></slot>
        </div>
      </div>
    `;
  }
};
e.styles = [
  f,
  g,
  v`
      :host {
        display: block;
      }

      .item {
        display: flex;
        align-items: center;
        gap: var(--r5-space-3);
        padding: var(--r5-space-3) var(--r5-space-4);
        background-color: var(--r5-bg-surface);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-md);
        transition: all var(--r5-duration-normal);
        text-decoration: none;
        color: inherit;
        position: relative;
      }

      :host([hoverable]) .item:hover {
        background-color: var(--r5-bg-hover);
        border-color: var(--r5-border-hover);
      }

      :host([active]) .item {
        background-color: var(--r5-color-primary-50);
        border-color: var(--r5-color-primary-200);
      }

      .leading {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        color: var(--r5-text-muted);
      }

      .content {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: var(--r5-space-0-5);
      }

      .label {
        font-size: var(--r5-text-sm);
        font-weight: var(--r5-font-medium);
        color: var(--r5-text);
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
      }

      .meta {
        font-size: var(--r5-text-xs);
        color: var(--r5-text-muted);
        display: flex;
        align-items: center;
        gap: var(--r5-space-3);
      }

      .trailing {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        flex-shrink: 0;
      }
    `
];
s([
  c({ type: Boolean, reflect: !0 })
], e.prototype, "hoverable", 2);
s([
  c({ type: Boolean, reflect: !0 })
], e.prototype, "active", 2);
e = s([
  m("ark-list-item")
], e);
export {
  e as A
};
//# sourceMappingURL=ark-list-item-CBTD-J5R.js.map
